import styles from "./OnlineStock.module.scss";
import classnames from "classnames";

type Props = {
  message: string | null;
  busy: boolean;
};

export function OnlineStockMessage({ message, busy }: Props) {
  return (
    <div
      className={classnames(styles.onlineStock)}
      data-testid="product:basket:stock"
      aria-busy={busy}
    >
      {message}
    </div>
  );
}
